import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import vendLogoSrc from "./base64/VendLogo.svg.js";
import partOfVendLogoSrc from "./base64/PartOfVendLogo.svg.js";
var Img = styled.img.withConfig({
  displayName: "VendLogo__Img",
  componentId: "sc-ptw8b6-0"
})(["width:", ";"], function (_ref) {
  var $type = _ref.$type;
  return $type === 'part-of' ? '184px' : '104px';
});

var VendLogo = function VendLogo(_ref2) {
  var className = _ref2.className,
      style = _ref2.style,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'default' : _ref2$type;
  return /*#__PURE__*/React.createElement(Img, {
    src: type === 'default' ? vendLogoSrc : partOfVendLogoSrc,
    alt: type === 'default' ? 'Vend logo' : 'Blocket är en del av Vend',
    className: className,
    style: style,
    $type: type
  });
};

VendLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.oneOf(['default', 'part-of'])
} : {};
export default VendLogo;
//# sourceMappingURL=VendLogo.js.map